module.exports = __webpack_public_path__ + "static/media/exclusive-photo-product.7a66dac1.jpg";